// extracted by mini-css-extract-plugin
export default {"amount":"ParkingAmountItem_amount__0cB8y"};